// one-comp-medication/model.ts

import {
  Medication
} from 'one-state-medication/src/medication';
/**
 * Represents the one-card-activeallergies modal
 */
export interface MedicationModal {
  medication?: Medication[];
}

